<template>
  <div>
    <VStack class="max-w-[556px] mx-auto" gap="9" center>
      <div>
        <VStack gap="6" center>
          <RowOfStars />
          <a :href="topReview.reviewUrl" target="_blank" rel="noopener noreferrer">
            <h2 class="text-center font-bold text-2xl text-[#313131]">“{{ topReview.reviewContent }}”</h2>
          </a>

          <div>
            <VStack gap="2">
              <p class="text-[#33ACE0] text-center my-0">{{ customerNameAndLocation }}</p>
              <HStack gap="1" class="items-center justify-center">
                <GreenCheck />
                <p class="text-[#5A5A5A] my-0 m-2">Verified customer</p>
              </HStack>
            </VStack>
          </div>
        </VStack>
      </div>
    </VStack>
    <VStack class="mt-[20px]" gap="5" center>
      <ReviewsIOLogo v-if="isReviewsIOReview()" />
      <div class="w-[70%] lg:w-[200px] border-t-[1px] border-[#DEDBD2] border-solid border-x-0 border-b-0" />
      <TrustPilotRating
        :imageHost="imageHostUrl"
        :score="trustPilotScore"
        :withScoreOutOfFive="false"
        :starts-sizing="sizing"
        :logo-sizing="sizing"
      />
    </VStack>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { HStack, VStack } from "@/Layout/Stack";
import TrustPilotRating from "./components/TrustPilot/TrustPilotRating.vue";
import ReviewsIOLogo from "@/Reviews/components/ReviewsIOLogo.vue";
import RowOfStars from "@/ComponentLibrary/RowOfStars.vue";
import GreenCheck from "./assets/green-check.svg?inline";
import { Review } from ".";

const props = defineProps<{
  imageHostUrl: string;
  trustPilotScore: number;
  topReview: Review;
  dimensions: "small" | "normal";
}>();

const sizing = computed(() => {
  if (props.dimensions === "normal") {
    return "medium";
  }

  return props.dimensions;
});

const customerNameAndLocation = computed(() => {
  return `${props.topReview.customerName}, ${props.topReview.customerLocation}`;
});

function isReviewsIOReview() {
  return props.topReview.reviewPlatform === "ReviewsIO";
}
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Roboto:wght@400;700&display=swap");
@tailwind utilities;
</style>
